
import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

export const avaliacaoFenotipicaRoutes: Routes = [
  {
    path: 'avaliacao-fenotipica',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Avaliação Fenotípica',
      breadcrumb: [{ label: 'Avaliação Fenotípica', url: '/avaliacao-fenotipica' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./agenda/agenda-list.component').then(
            (m) => m.AgendaListComponent,
          ),
        data: {
          title: 'Agenda de Avaliação Fenotípica',
          roles: [Role.AVALIACAO_FENOTIPICA_VISUALIZAR],
          breadcrumb: [{ label: 'Agenda', url: '/avaliacao-fenotipica' }],
        },
      },
      {
        path: 'calendario',
        loadComponent: () =>
          import('./calendario/calendario.component').then(
            (m) => m.CalendarioComponent,
          ),
        data: {
          title: 'Calendário de Avaliações',
          roles: [Role.AVALIACAO_FENOTIPICA_VISUALIZAR],
          breadcrumb: [{ label: 'Calendário', url: '/avaliacao-fenotipica/calendario' }],
        },
      },
      {
        path: 'enviar-emails',
        loadComponent: () =>
          import('./agenda/agenda-list.component').then(
            (m) => m.AgendaListComponent,
          ),
        data: {
          title: 'Enviar e-mails',
          roles: [Role.AVALIACAO_FENOTIPICA_ENVIAR_EMAIL],
          acao: 'enviar-emails',
          breadcrumb: [{ label: 'Enviar e-mails', url: '/avaliacao-fenotipica/enviar-emails' }],
        },
      },
    ],
  },
]
